export default __webpack_public_path__ + "static/media/cogip.b50493e3.png";